
export default class UserManagementData {
    public id: number;
    public type: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public fullName: string;
    public phoneNumber: string; // string or number?
    public isTenant: boolean;

    constructor(
        id: number,
        type: string = '',
        email: string = '',
        firstName: string = '',
        lastName: string = '',
        phoneNumber: string = '', // string or number?
        isTenant: boolean = false,
    ) {
        this.id = id;
        this.type = type;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.isTenant = (isTenant as boolean);
        this.fullName = firstName + ' ' + lastName;
    }

    get persisted(): boolean {
        return (this.id !== -1);
    }


    public dataEquals(user: UserManagementData): boolean {
        // Check if this object's values are equal to the given object's
        if (
            this.id === user.id &&
            this.type === user.type &&
            this.email === user.email &&
            this.firstName === user.firstName &&
            this.lastName === user.lastName &&
            this.phoneNumber === user.phoneNumber &&
            this.isTenant === user.isTenant
        ) {
            return true;
        } else {
            return false;
        }
    }

    public cloneData(user: UserManagementData) {
        this.type = user.type;
        this.email = user.email;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.phoneNumber = user.phoneNumber;
        this.isTenant = user.isTenant;
    }
}
